import React from "react";
import { Table } from "reactstrap";
import { FormattedDate } from "react-intl";
import MediaQuery from "react-responsive";

import style from "./Grid.module.scss";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";

const ProductActivity = ({ activity, opsViewAccountName }) => (
  <MediaQuery minWidth={900}>
    {(matches) => (matches ? <TableDefault items={activity} opsViewAccountName={opsViewAccountName}/> : <TableSm items={activity} opsViewAccountName={opsViewAccountName}/>)}
  </MediaQuery>
);

const TableDefault = ({ items, opsViewAccountName }) => (
  <div className={style.grid}>
    <h6 className="my-3">Product Activity</h6>
    <Table responsive hover>
      <thead>
        <tr>
          <th>Date</th>
          <th>Description</th>
          <th>Product</th>
          <th>Account</th>
          <th style={{ minWidth: 110 }}>Balance type</th>
          <th className="text-right">Debit</th>
          <th className="text-right">Credit</th>
        </tr>
      </thead>
      <tbody>
        {items.map((item) => {
          const credit =
            parseInt(item.ProductActivityDebitCredit, 10) > 0 ? parseFloat(item.ProductActivityVolume) : "";
          const debit =
            parseInt(item.ProductActivityDebitCredit, 10) > 0 ? "" : parseFloat(item.ProductActivityVolume);
          return (
            <tr key={item.ProductActivityId}>
              <td>
                <FormattedDate value={`${item.ProductActivitySettlementDate}T00:00`} />
              </td>
              <td>{item.ProductActivityDescription}</td>
              <td>{item.AssetTicker}</td>
              {opsViewAccountName == undefined ?
              (
                <td>{item.ProductActivityAccountName}</td>
              )
              :
              (
                opsViewAccountName ?
                (
                  <td>{item.ProductActivityAccountName}</td>
                )
                :
                (
                  <td>{item.ProductActivityAccountNumber}</td>
                )
              )
              } 
              <td>{item.ProductActivityBalanceType}</td>
              <td className="text-right">
                <FormattedNumber value={debit} dataTypeDecimalName={"quantity"} />
              </td>
              <td className="text-right">
                <FormattedNumber value={credit} dataTypeDecimalName={"quantity"} />
              </td>
            </tr>
          );
        })}
        {items.length === 0 && (
          <tr>
            <td colSpan={8} style={{ textAlign: "center" }}>
              No Product Activity
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </div>
);

const TableSm = ({ items, opsViewAccountName }) => (
  <div className={style.grid}>
    <h6 className="my-3">Product Activity</h6>
    <Table responsive hover>
      <thead>
        <tr>
          <th>Date</th>
          <th>Description - Account</th>
          <th>Balance type</th>
          <th className="text-right">Volume</th>
        </tr>
      </thead>
      <tbody>
        {items.map((item) => (
          <tr key={item.ProductActivityId}>
            <td>
              <FormattedDate value={`${item.ProductActivitySettlementDate}T00:00`} />
            </td>
            <td>
              {item.ProductActivityDescription}
              {opsViewAccountName == undefined ?
              (
                " - " + 
                <td>{item.ProductActivityAccountName}</td>
              )
              :
              (
                opsViewAccountName ?
                (
                  " - " + 
                  <td>{item.ProductActivityAccountName}</td>
                )
                :
                (
                  <td>{item.ProductActivityAccountNumber}</td>
                )
              )
              } 
            </td>
            <td>{item.ProductActivityBalanceType}</td>
            <td className="text-right">
              <FormattedNumber value={item.ProductActivityTotal} dataTypeDecimalName={"QUANTITY"} />
            </td>
          </tr>
        ))}
        {items.length === 0 && (
          <tr>
            <td colSpan={8} style={{ textAlign: "center" }}>
              No Product Activity
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </div>
);

export default ProductActivity;
